var map = {
	"./HAIR1.svg": 68414,
	"./HAIR10.svg": 5276,
	"./HAIR11.svg": 1661,
	"./HAIR12.svg": 24338,
	"./HAIR2.svg": 40443,
	"./HAIR3.svg": 18835,
	"./HAIR4.svg": 16724,
	"./HAIR5.svg": 98179,
	"./HAIR6.svg": 31566,
	"./HAIR7.svg": 26298,
	"./HAIR8.svg": 6161,
	"./HAIR9.svg": 3234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19305;